import { render, staticRenderFns } from "./SlidePanel.vue?vue&type=template&id=45e84a46&scoped=true&"
import script from "./SlidePanel.vue?vue&type=script&lang=js&"
export * from "./SlidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e84a46",
  null
  
)

export default component.exports